
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.667 2.667a.667.667 0 110 1.333H4v8h.667a.667.667 0 110 1.333H3.333a.667.667 0 01-.666-.666V3.333c0-.368.298-.666.666-.666zm6.406 2.12c.3-.211.715-.14.927.16l1.88 2.666a.667.667 0 01-.013.787l-2 2.667a.667.667 0 01-1.067-.8l1.2-1.6H6.667a.667.667 0 010-1.334h5.393L10.913 5.72a.667.667 0 01.16-.933z"}})])
          )
        }
      }
    